import { Debug } from "./debug";
import { Dot } from "./dot";
import { JsonStyled } from "./jsonStyled";

export const DebugDotJson = ({ data, jsonProps, ...rest }) => {
  return (
    <Debug {...rest}>
      <Dot>
        <JsonStyled data={data} {...jsonProps} />
      </Dot>
    </Debug>
  );
};
